import React from "react";
import AboutDriveImage1 from "../../assets/img/galleryy.jpg";
import "../WhatDrivesUs.css";

export default function GallerySection() {
  return (
    <div className="wd-img top-img">
            <img src={AboutDriveImage1} alt="Care Team" />
          </div>
  );
}

